import { Typography, styled } from '@material-ui/core';

export const ParagraphText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Open Sans',
  fontSize: 14,
  lineHeight: '22px',
  color: theme.palette.text.primary,
  marginBottom: 12,
}));
